import { Component, Injector, OnInit } from '@angular/core';
import { Input } from '@angular/core';
import { Detail } from '../../classes/prize-for-precision';
import { DrupalLangClass } from '../../../../common-page-components/classes/drupal-lang-class';

@Component({
  selector: 'app-price-for-precision-details',
  templateUrl: './price-for-precision-details.component.html',
  styleUrls: ['./price-for-precision-details.component.scss']
})
export class PriceForPrecisionDetailsComponent extends DrupalLangClass implements OnInit {
  @Input()
  details: Array<Detail>
  constructor(injector: Injector,
  ) {
    super(injector);

  }

  ngOnInit() {
  }

}
